/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* ===== ルックブック (sections/bm-lookbook.liquid)・2026-09-15 ===== */
document.addEventListener('DOMContentLoaded', function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('.bm-lookbook__item'));
  if (!items.length) return;

  /* --- スクロールリビール: 視界に入ったタイミングで静かに立ち上げる。
         prefers-reduced-motion 時と非対応ブラウザでは何もしない (常時表示のまま)。 --- */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('bm-reveal--in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var vh = window.innerHeight;
    items.forEach(function (el) {
      el.classList.add('bm-reveal');
      // 初期ビューポート内は IO を待たず即表示 (初回描画が IO のタイミングに依存しないため)
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('bm-reveal--in');
      else io.observe(el);
    });
  }

  /* --- ライトボックス: 画像クリックで拡大 (トリミングなしの原寸比)。
         ← → で前後、Esc / 背景クリックで閉じる、スマホは横スワイプで送る。 --- */
  // 前後送りは見た目の並び順に合わせる (スマホの市松では CSS の order で並びが入れ替わるため、開くたびに取り直す)
  var imgs = [];
  var visualImgs = function () {
    return items
      .map(function (el, i) { return { el: el, i: i, o: parseInt(getComputedStyle(el).order, 10) || 0 }; })
      .sort(function (a, b) { return a.o - b.o || a.i - b.i; })
      .map(function (x) { return x.el.querySelector('img'); })
      .filter(Boolean);
  };
  var lb = document.createElement('div');
  lb.className = 'bm-lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Lookbook viewer');
  lb.innerHTML =
    '<img class="bm-lb__img" alt="">' +
    '<div class="bm-lb__counter" aria-hidden="true"></div>' +
    '<button class="bm-lb__btn bm-lb__prev" type="button" aria-label="Previous">&#8249;</button>' +
    '<button class="bm-lb__btn bm-lb__next" type="button" aria-label="Next">&#8250;</button>' +
    '<button class="bm-lb__btn bm-lb__close" type="button" aria-label="Close">&#215;</button>';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector('.bm-lb__img');
  var lbCounter = lb.querySelector('.bm-lb__counter');
  var idx = 0;
  var largeSrc = function (img) {
    var url = img.currentSrc || img.src;
    return /[?&]width=/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=1800') : url;
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  // <img> に新しい src を入れても読み込み完了まで前の画像が残るため、切替時は前の画像を即座に消し、
  // 読み込み完了後にフェードインさせる。連打時の追い越しは token で判定し、最後に要求した画像だけを出す。
  var loadToken = 0;
  var show = function (i) {
    idx = (i + imgs.length) % imgs.length;
    var target = largeSrc(imgs[idx]);
    var token = ++loadToken;
    lbImg.classList.remove('is-loaded');
    lbImg.removeAttribute('src');
    lbImg.alt = imgs[idx].alt || '';
    lbCounter.textContent = pad(idx + 1) + ' / ' + pad(imgs.length);
    var pre = new Image();
    pre.onload = function () {
      if (token !== loadToken) return;
      lbImg.src = target;
      lbImg.classList.add('is-loaded');
    };
    pre.src = target;
    [idx + 1, idx - 1].forEach(function (j) { new Image().src = largeSrc(imgs[(j + imgs.length) % imgs.length]); });
  };
  var open = function (i) { show(i); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
  var close = function () {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    loadToken++;
    lbImg.classList.remove('is-loaded');
    lbImg.removeAttribute('src');
  };
  items.forEach(function (el) {
    var img = el.querySelector('img');
    if (!img) return;
    img.addEventListener('click', function () { imgs = visualImgs(); open(imgs.indexOf(img)); });
  });
  lb.querySelector('.bm-lb__close').addEventListener('click', close);
  lb.querySelector('.bm-lb__prev').addEventListener('click', function () { show(idx - 1); });
  lb.querySelector('.bm-lb__next').addEventListener('click', function () { show(idx + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });
  var touchX = null;
  lb.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 48) { if (dx < 0) show(idx + 1); else show(idx - 1); }
  }, { passive: true });
});

/* ===== スマホ 3 列: 表示切り替えボタンで選んだ列数を保存 (テーマ設定「スマホの商品一覧を 3 列にする」・2026-09-17) =====
   3 列モードの時、Liquid はカート属性 bm_mobile_grid だけを読む (テーマ本体の属性には 3 列にする前の選択が残っているため)。
   テーマ本体のボタン処理 (theme.js) はそのまま動かし、ここでは選んだ列数を別の属性に書くだけ。 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bm-grid3] [data-action="change-layout-mode"][data-grid-type="mobile"]');
  if (!btn) return;
  fetch(window.routes.cartUrl + '/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ attributes: { bm_mobile_grid: btn.getAttribute('data-count') } })
  });
});

/* ===== 商品カード: タッチ端末でも「触れている間」は 2 枚目の画像を見せる (2026-10-09) =====
   テーマ本体は 2 枚目の画像を hover:hover (マウス) でしか出さず、タッチ端末では読み込みも止めている (display:none)。
   指が乗っているカード (スクロール中に指の下を通るカードも) にホバー状態を与え、指を離したら戻す。タップは通常どおり遷移する。
   2 枚目はパソコンと同じく、カードが画面に入った時点で先に読み込んでおく (custom.css)。
   初めて触れた時に読み込みが間に合わず切り替わらない問題への対処 (2026-10-09 実機で発覚)。読み込み前に触れた場合だけ、ここで読み込みを急がせる。 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  var CLS = 'bm-touch-hover', SHOWN = 'bm-touch-hover--shown';
  var active = null;

  function wrapperFrom(el) {
    var w = el && el.closest ? el.closest('.ProductItem__ImageWrapper--withAlternateImage') : null;
    return w && w.querySelector('.ProductItem__Image--alternate') ? w : null;
  }
  function reveal(w) {
    var img = w.querySelector('.ProductItem__Image--alternate');
    clearTimeout(w._bmHideTimer);
    w.classList.add(CLS);
    var show = function () {
      if (active !== w) return;
      void img.offsetWidth; // display:block を先に確定させ、続く opacity 変化をトランジションさせる
      w.classList.add(SHOWN);
    };
    if (img.complete && img.naturalWidth > 0) { show(); return; }   // lazysizes は src ではなく srcset に入れるので、src の有無では判定しない
    img.addEventListener('load', show, { once: true });
    // 触れた瞬間に読み込みを始める (lazysizes の見え方の判定を待たない)
    if (window.lazySizes && img.classList.contains('Image--lazyLoad')) window.lazySizes.loader.unveil(img);
  }
  // 戻りも同じクロスフェード: まず SHOWN を外して 1 枚目と 2 枚目を入れ替え、
  // フェードが終わってから 2 枚目を display:none に戻す (即時に消すと背景が透けて光って見える)
  var FADE_MS = 380;
  function hide(w) {
    w.classList.remove(SHOWN);
    clearTimeout(w._bmHideTimer);
    w._bmHideTimer = setTimeout(function () {
      if (active !== w) w.classList.remove(CLS);
    }, FADE_MS);
  }
  function moveTo(w) {
    if (w === active) return;
    if (active) hide(active);
    active = w;
    if (w) reveal(w);
  }
  function end() { if (active) hide(active); active = null; }

  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    moveTo(wrapperFrom(e.target));
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (e.touches.length !== 1) return;
    var t = e.touches[0];
    moveTo(wrapperFrom(document.elementFromPoint(t.clientX, t.clientY)));
  }, { passive: true });
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
})();
